import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { validateEmptyOrNull } from "../utilities/libs";

// manage customer
export const manageCustomerUrls = {
	customer_detials_url: "/cstracking/customer-contacts",
};

export const getCustomerDetail = () => ({
	customerId: "",
	phoneNumber: "",
	warehouse: "",
	emailAddress: "",
	recoveryTime: "",
	recoveryDay: "",
	startReceivingHours: "",
	endRecevingHours: "",
});

export const CUSTOMER_FIELDS = [
	{ property: "customerId", label: "Customer ID *", value: "", isEditable: true },
	{ property: "phoneNumber", label: "Phone Number", value: "", isEditable: true },
	{ property: "warehouse", label: "Warehouse", value: "", isEditable: true },
	{ property: "emailAddress", label: "Email Address *", value: "", isEditable: true },
	{ property: "recoveryTime", label: "Select Hours", value: "", isEditable: true },
	{ property: "recoveryDay", label: "Recovery Day", value: "", isEditable: true },
	{ property: "startReceivingHours", label: "Start Time", value: "", isEditable: true },
	{ property: "endRecevingHours", label: "End Time", value: "", isEditable: true },
];

export const CUSTOMER_MANAGEMENT_TABLE_HEADINGS = [
	{ name: "Customer ID", key: "customerId", sortable: false, icon: [] },
	{ name: "Phone Number", key: "phoneNumber", sortable: false, icon: [] },
	{
		name: "Warehouse",
		key: "warehouse",
		sortable: false,
		icon: []
	},
	{ name: "Email Address", key: "emailAddress", sortable: false, icon: [] },
	{ name: "Auto Recovery Window", key: "autoRecoveryWindow", sortable: false, icon: [] },
	{ name: "Hours of Receiving", key: "hoursOfReceiving", sortable: false, icon: [] },
	{
		name: "Action",
		key: "",
		sortable: false,
		icon: [
			{ icon: EditIcon, type: "edit" },
			{ icon: DeleteIcon, type: "delete" },
		],
		align: "center"
	},
];

export const AUTO_RECOVERY_DAY_OPTIONS = [
	{ label: 'Today', value: 'Today' },
	{ label: 'Tomorrow', value: 'Tomorrow' },
];

export const DASHBOARD_CUSTOMER_CONSTANTS = {
	INVALID_SEARCH_TYPE: "Please select search type",
	EDIT_CUSTOMER: "Edit Customer Contact Details",
	ADD_CUSTOMER: "Add Customer Contact Details",
	CUSTOMER_Details: "Customer Details",
	START: "start",
	END: "end",
	DEFAULT_SEARCH_PLACEHOLDER: "Search by Customer ID",
	ADD_NEW_BUTTON_LABEL: "Add New",
	CUSTOMER_DETAILS_FOUND_SUCCESSFULLY: "Customer details are found successfully",
	NO_CUSTOMER_DETAILS_FOUND: "No Customer details are found",
	CUSTOMER_ADDED_SUCCESSFULLY: "Customer details are created successfully",
	ERROR_CREATING_CUSTOMER: "Error creating a Customer",
	CUSTOMER_UPDATED_SUCCESSFULLY: "Customer details are updated successfully",
	ERROR_UPDATING_CUSTOMER: "Error updating the Customer",
	CUSTOMER_DELETED_SUCCESSFULLY: "Customer details are deleted successfully",
	ERROR_DELETING_CUSTOMER: "Error deleting the Customer",
	MANDATORY_FIELDS_VALIDATION_MESSAGE: "Please fill up all mandatory fields",
	DAY_FIELD_VALIDATION_MESSAGE: "Please Select Today or Tomorrow",
	HOURS_FIELDS_VALIDATION_MESSAGE: "Please Select Hours",
	END_TIME_FIELDS_VALIDATION_MESSAGE: "Please Enter End Time",
	START_TIME_FIELDS_VALIDATION_MESSAGE: "Please Enter Start Time",
	ROW_ITEM: "item",
	HOURS: 'hrs',
	HOUR: 'hr',
	CUSTOMER_ID_EXISTS_ERROR: "Customer ID Already Exist"
};

export const getBooleanValue = (value) => {
	if (typeof value === 'boolean') {
		// If it's already a boolean, return it
		return value;
	} else if (typeof value === 'string') {
		// Check if the string is "true" or "false" (case insensitive)
		if (value.toLowerCase() === "true") {
			return true;
		} else if (value.toLowerCase() === "false") {
			return false;
		}
	}
	// Return false for any other type or unrecognized string
	return false;
}

export const format24HourToAmPm = (value) => {
	if (validateEmptyOrNull(value)) {
		return "";
	}
	const [hourStr, minute] = value.split(":");
	let hour = parseInt(hourStr, 10);
	const ampm = hour < 12 ? "AM" : "PM";
	hour = hour % 12;
	if (hour === 0) hour = 12;

	return `${hour.toString().padStart(2, '0')}:${minute} ${ampm}`;
}